import React, { useRef, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import { CardIdHandler, CardStateHandler, CreatedDateHandler, NumberFormatter } from './service';
import List from '../grid.component';

const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
  return <NumberFormatter value={value} />;
};

const CardOverViewGrid = ((props) => {
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [copiedId, setCopiedId] = useState('');
  const handleIdCopy = useCallback((id) => () => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])
  const details = useCallback((data) => () => {
    navigate(`/cards/cardDetails/${data.id}/transactions`)
  }, [navigate])
  const cardIdHandler = useCallback((props) => {
    return <CardIdHandler handleCopy={handleIdCopy} copiedId={copiedId} data={props?.dataItem} handledetails={details} />
  }, [copiedId, handleIdCopy, details])
  const createdDateHandler = useCallback((props) => {
    return <CreatedDateHandler data={props?.dataItem} />
  }, [])
  const cardStateHandler = useCallback((props) => {
    return <CardStateHandler data={props?.dataItem} />
  }, [])
  const customcells = {
    "id": cardIdHandler,
    "cardAmount": renderNumberColumn("cardAmount"),
    "activationFee": renderNumberColumn("activationFee"),
    "depositFee": renderNumberColumn("depositFee"),
    "createdDate": createdDateHandler,
    "status": cardStateHandler,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/CardsOverView`}
        pSize={10}
        className="custom-grid"
        additionalParams={props?.filterValues}
        ref={gridRef}
        showExcelExport={props?.isExcelExport}
        pKey={"Cards"}
        screenName={'Cards'}
        renderCustomCell={renderCustomCell}
      />
    </div>
  )
})
export default CardOverViewGrid